export default function (app, inject) {
  inject('CDN', string => 'https://cdn.humnutrition.com/assets/' + string)
  inject(
    'CDN2x',
    string => 'https://cdn.humnutrition.com/assets/' + string + ' 2x'
  )
}
